var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulldozer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14480",
    "data-name": "Group 14480",
    transform: "translate(-0.112 -0.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M8.662,43.335A3.662,3.662,0,1,1,5,47a3.662,3.662,0,0,1,3.662-3.662",
    transform: "translate(-2.803 -24.037)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M55.371,41.315h3.141a37.989,37.989,0,0,1-2.93-14.649H52.653a40.716,40.716,0,0,0,.664,7.324H45.329a3.664,3.664,0,1,0,3.587,2.93h5.055a41.617,41.617,0,0,0,1.4,4.394",
    transform: "translate(-23.357 -14.693)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M19.042,0H5.859V2.929h2.93v8.789H5.859V7.323H2.93v4.394H0v5.127H5.859A5.865,5.865,0,0,1,11.718,22.7v.732h4.394V22.7a5.865,5.865,0,0,1,5.859-5.859h1.465V11.718Z",
    transform: "translate(0 0.256)",
    fill: "#ff9100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulldozer);
export default __webpack_public_path__ + "static/media/bulldozer.58b66319367f84f64398d7999759247b.svg";
export { ForwardRef as ReactComponent };